import { render } from "./RequestTableHeader.vue?vue&type=template&id=0d812782&scoped=true"
const script = {}

import "./RequestTableHeader.vue?vue&type=style&index=0&id=0d812782&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d812782"]])

export default __exports__